<template>
  <ITMPage>
    <div class="container">
      <h2 class="col-12">Summary Reports</h2>
      <Loader v-if="!generatorOptions || isLoading" />
      <div class="hvh-flex wrap">
        <SearchableDropdown class="col-12 col-sm-6 col-md-4" :options="generatorOptions" label="Select Product" @selected="updateLiveFilter('generator', $event)" />
        <SearchableDropdown class="col-12 col-sm-6 col-md-4" :options="customerDeatils" label="Select Customer" @selected="updateLiveFilter('customer', $event)" />
        <SearchableDropdown class="col-12 col-sm-6 col-md-4" :options="productStatus" label="Select Product Status" @selected="updateLiveFilter('status', $event)" />
      </div>
      <div class="hvh-flex wrap">
        <div class="col-12 col-md-6 col-lg-4 pt-0">
          <DateRangePicker class="p-4" header="Delivery Date Range" :value="liveFilters.dateRange || { from: claimsDate.min, to: claimsDate.max }" :min="claimsDate.min" :max="claimsDate.max" @input="updateLiveFilter('dateRange', $event)" />
        </div>
        <div class="col-12 col-md-6 col-lg-8">
          <v-treeselect class="spcore-states-treeselect" :value="selectedStates" :multiple="true" :options="states" placeholder="State" @input="updateLiveFilter('area', { states: $event })" />
        </div>
      </div>
      <div class="hvh-flex end col-12">
        <v-btn flat class="hvh-btn hvh-btn--primary m-1" @click="submitTracking">Search</v-btn>
        <v-btn flat class="hvh-btn hvh-btn--primary m-1" @click="submitReset">Reset</v-btn>
      </div>
      <div class="col-12 mt-3">
        <ExcelExporter :data="gridData" :columns="excelColumns" :fileName="excelFileName" />
        <v-alert border="top" type="warning" color="red" outline :value="true" v-if="statusMessage">
          {{ statusMessage }}
        </v-alert>
        <ITMGrid :data="gridData" :isLoading="isLoading" @view-order-details="fetchOrderDetails" v-if="!statusMessage && gridData" />
      </div>

      <ITMCreateOrder :value="orderDetails" :isLoading="isLoading" :readOnly="true" @close="orderDetails = null" v-if="orderDetails" />
    </div>
  </ITMPage>
</template>

<script>
import ITMPage from '../../components/itm/ITMPage.vue'
import ITMCreateOrder from '../../components/itm/ITMCreateOrder.vue'
import SearchableDropdown from '../../components/itm/ITMDropdown.vue'
import ITMGrid from '../../components/itm/ITMGrid.vue'
import ExcelExporter from '../../components/itm/ITMExcelExporter.vue'
import axios from '../../axios'
import VTreeselect from '@riophae/vue-treeselect';
import DateRangePicker from '../../components/common/date/DateRangePicker.vue';
import { getDemographics } from '../../libraries/cohorts';
import { errorDebug, } from '../../libraries/common'

export default {
  components: { VTreeselect, ITMPage, SearchableDropdown, ITMGrid, DateRangePicker, ITMCreateOrder, ExcelExporter },
  data() {
    var currentDate = new Date();
    var maxDate = new Date(currentDate.getFullYear() + 20, currentDate.getMonth(), currentDate.getDate());
    var states = getDemographics().states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      data: null,
      generatorOptions: [],
      customerDeatils: [],
      productStatus: [],
      liveFilters: { area: {} },
      isLoading: false,
      trackingNumber: '',
      statusMessage: '',
      selectedStates: null,
      orderDetails: null,
      excelColumns: [ // Define your columns here
        { label: 'Order ID', field: 'orderId' },
        { label: 'Product Name', field: 'productName' },
        { label: 'Customer Name', field: 'customerName' },
        { label: 'Product Status', field: 'productStatus' },
        { label: 'Fedex Tracking Number', field: 'fedexId' }

      ],
      excelFileName: 'summary_reports.xlsx',
      claimsDate: { min: new Date('2015-01-01').toISOString(), max: maxDate.toISOString() },
      gridData: null,
      states: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: getDemographics()[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
    };
  },
  computed: {
  },
  methods: {
    getData() {
      this.isLoading = true;
      axios.get(`/api/ITM/Orders`)
        .then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    submitReset() {
      // Reset all filter values to their initial states
      // this.liveFilters = { area: {} };
      // this.selectedStates = null;
      // this.gridData = null;
      // this.statusMessage = '';
      // this.orderDetails = null;
      // Reload the page to reset it
      window.location.reload();
    },

    fetchOrderDetails(orderId, orderKey) {

      if (orderId) {

        var orderDetails = this.data.find(f => f.orderId === orderId && f.id === orderKey);
        if (orderDetails) {

          this.orderDetails = orderDetails;
        } else {
          console.error('Order details not found.');
        }
      } else {
        console.error('Invalid orderId.');
      }

    },
    updateLiveFilter(key, value) {
      this.liveFilters = { ...this.liveFilters, [key]: value };
    },
    submitTracking() {
      this.isLoading = true;
      axios.post(`/ITM/DashBoard/GridData`, this.liveFilters)
        .then(({ data }) => {
          this.gridData = data;
          if (!data.length) {
            this.statusMessage = 'No Record found with this Selection';
          } else {
            this.statusMessage = '';
          }
        })
        .catch(error => {
          console.error('Error submitting tracking:', error);
          this.statusMessage = 'Unfortunately, we are unable to retrieve your tracking results at this time. Please try again later.';
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    fetchGeneratorOptions() {
      this.isLoading = true;
      axios.get(`/ITM/DashBoard/GetDdlProduct`)
        .then(({ data }) => this.generatorOptions = data.map(item => ({
          value: item.productKey,
          label: item.name
        })))
        .catch(Error)
        .then(() => this.isLoading = false);
    },
    fetchCustomerOptions() {
      this.isLoading = true;
      axios.get(`/ITM/DashBoard/GetDdlCustomer`)
        .then(({ data }) => this.customerDeatils = data.map(item => ({
          value: item.customerKey,
          label: item.name
        })))
        .catch(Error)
        .then(() => this.isLoading = false);
    },
    fetchProductStatus() {
      this.isLoading = true;
      axios.get(`/ITM/DashBoard/GetProductStatus`)
        .then(({ data }) => this.productStatus = data.map(item => ({
          value: item.statusKey,
          label: item.name
        })))
        .catch(Error)
        .then(() => this.isLoading = false);

    },

    dateSelected(event) {
      this.liveFilters = {
        ...this.liveFilters,
        dateRange: event
      };
    },
    stateSelected(event) {
      var states = event.map(f => this.states.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);
      this.liveFilters = {
        ...this.liveFilters,
        area: {
          ...this.liveFilters.area,
          states
        }
      };
    },

  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMDashboard'] = this;
    this.getData();
    this.fetchGeneratorOptions();
    this.fetchCustomerOptions();
    this.fetchProductStatus();
  },
}
</script>

<style lang="scss" scoped>
</style>